module.exports = __webpack_public_path__ + "static/media/android-icon.e0fb0b16.png";